import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: localStorage.getItem("accessToken") ? true : false,
  accessToken: localStorage.getItem("accessToken") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,

  user: JSON.parse(localStorage.getItem("user")) || null,
  error: null,
  loading: false,
  loginModal: false,
  resetPassword: false,
  registerModal: false,
  registrationSuccess: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    loginSuccess: (state, action) => {
      const { accessToken, refreshToken, user } = action.payload;
      state.isAuthenticated = true;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.user = user;
      state.error = null;
      state.loading = false;

      // Store auth data in localStorage
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("user", JSON.stringify(user));
    },

    loginFailure: (state, action) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.user = null;
      state.error = action.payload;
      state.loading = false;
    },

    updateTokens: (state, action) => {
      const { accessToken, refreshToken } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;

      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
    },

    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    updateBalance: (state, action) => {
      const { balance } = action.payload;

      // Update only if the balance has changed to avoid unnecessary state updates
      if (state.user && state.user.balance !== balance) {
        state.user = { ...state.user, balance };
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },

    registrationSuccess: (state) => {
      state.registrationSuccess = true;
      state.error = null;
      state.loading = false;
    },

    registrationFailure: (state, action) => {
      state.registrationSuccess = false;
      state.error = action.payload;
      state.loading = false;
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.user = null;
      state.error = null;
      state.loading = false;

      // Clear localStorage
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
    },

    clearError: (state) => {
      state.error = null;
    },

    // Modal controls
    setLoginModal: (state, action) => {
      state.loginModal = action.payload;
    },

    setRegisterModal: (state, action) => {
      state.registerModal = action.payload;
    },
    // Modal controls
    setResetPasswordModal: (state, action) => {
      state.resetPassword = action.payload;
    },
  },
});

// Actions
export const {
  updateBalance,
  setLoading,
  loginSuccess,
  loginFailure,
  updateTokens,
  updateUser,
  registrationSuccess,
  registrationFailure,
  logout,
  clearError,
  setResetPasswordModal,
  setLoginModal,
  setRegisterModal,
} = authSlice.actions;

// Selectors
export const selectAuth = (state) => state.auth;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAccessToken = (state) => state.auth.accessToken;
export const selectRefreshToken = (state) => state.auth.refreshToken;
export const selectUser = (state) => state.auth.user;
export const selectAuthError = (state) => state.auth.error;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectLoginModal = (state) => state.auth.loginModal;
export const selectRegisterModal = (state) => state.auth.registerModal;
export const selectResetPasswordModal = (state) => state.auth.resetPassword;
export const selectRegistrationSuccess = (state) =>
  state.auth.registrationSuccess;

export const authReducer = authSlice.reducer;
